import { defineStore } from "pinia";
import http from "@/http";
import {
  LIST_EQUIPE,
  ADD_EQUIPE,
  UPDATE_EQUIPE,
  DEL_EQUIPE,
  LIST_DIARIO,
  ADD_DIARIO,
  UPDATE_DIARIO,
  DEL_DIARIO,
  LIST_DESPESA,
  ADD_DESPESA,
  UPDATE_DESPESA,
  DEL_DESPESA,
} from "@/http/url";

export const useEquipeStore = defineStore("EquipeStore", {
  state: () => {
    return {
      equipes: [],
      diarios: [],
      despesas: [],
      totalDespesas: Number(0.0),
      loaded: false,
    };
  },

  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    //AÇÕES SOBRE AS EQUIPES
    LISTAR_EQUIPES() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_EQUIPE)
          .then((response) => {
            this.equipes = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_EQUIPE(equipe) {
      return http
        .post(ADD_EQUIPE, equipe)
        .then((response) => this.equipes.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_EQUIPE(equipe) {
      return http
        .put(`${UPDATE_EQUIPE + equipe.id}`, equipe)
        .then((response) => {
          const index = this.equipes.findIndex((objeto) => objeto.id === response.data.id);
          this.equipes[index] = response.data;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },

    REMOVER_EQUIPE(id) {
      return http.delete(`${DEL_EQUIPE + id}`).then(() => (this.equipes = this.equipes.filter((object) => object.id != id)));
    },

    //AÇÕES SOBRE OS DIARIOS
    LISTAR_DIARIOS(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${LIST_DIARIO + id}`)
          .then((response) => {
            this.diarios = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_DIARIO(diario) {
      return http.post(ADD_DIARIO, diario).catch((erro) => {
        console.log(erro);
      });
    },

    ALTERAR_DIARIO(diario) {
      return http.put(`${UPDATE_DIARIO + diario.id}`, diario);
    },

    REMOVER_DIARIO(id) {
      return http.delete(`${DEL_DIARIO + id}`).then(() => (this.diarios = this.diarios.filter((item) => item.id != id)));
    },

    //AÇÕES SOBRE AS DESPESAS
    LISTAR_DESPESAS(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${LIST_DESPESA + id}`)
          .then((response) => {
            this.despesas = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_DESPESA(despesa) {
      return http
        .post(ADD_DESPESA, despesa)
        .then((response) => this.despesas.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_DESPESA(despesa) {
      return http
        .put(`${UPDATE_DESPESA + despesa.id}`, despesa)
        .then((response) => {
          const index = this.despesas.findIndex((objeto) => objeto.id === response.data.id);
          this.despesas[index] = response.data;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },

    REMOVER_DESPESA(id) {
      return http.delete(`${DEL_DESPESA + id}`).then(() => (this.despesas = this.despesas.filter((object) => object.id != id)));
    },
  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    //EQUIPES
    getEquipes() {
      return this.equipes;
    },

    getEquipeById: (state) => {
      return (id) => {
        return state.equipes.filter((object) => !id || object.id == id);
      };
    },

    getFilterEquipes: (state) => {
      return (filtro) => {
        let filtrada = state.equipes;
        filtrada = filtrada.filter(
          (obj) => !filtro || (obj.descricao.includes(filtro.descricao) && obj.lider.includes(filtro.lider))
        );
        return filtrada;
      };
    },

    //DIARIOS
    getDiarios() {
      return this.diarios;
    },

    getDiarioById: (state) => {
      return (id) => {
        return state.diarios.filter((object) => !id || object.id == id);
      };
    },

    getFilterDiarios: (state) => {
      return (filtro) => {
        let filtrada = state.diarios;
        filtrada = filtrada.filter(
          (obj) => !filtro || (obj.atividade.includes(filtro.atividade) && obj.alteracao.includes(filtro.alteracao))
        );
        return filtrada;
      };
    },

    getPeriodDiarios: (state) => {
      return (periodo) => {
        let filtrada = state.diarios;
        filtrada = filtrada.filter(
          (diario) =>
            new Date(diario.data).getTime() >= new Date(periodo.inicio).getTime() &&
            new Date(diario.data).getTime() <= new Date(periodo.final).getTime()
        );

        return filtrada;
      };
    },

    //DESPESAS
    getDespesas() {
      return this.despesas;
    },

    getTotalDespesas() {
      return this.totalDespesas;
    },

    getDespesaById: (state) => {
      return (id) => {
        return state.despesas.filter((object) => !id || object.id == id);
      };
    },

    getFilterDespesas: (state) => {
      return (filtro) => {
        let filtrada = state.despesas;
        filtrada = filtrada.filter(
          (obj) => !filtro || (obj.descricao.includes(filtro.descricao) && obj.responsavel.includes(filtro.responsavel))
        );
        return filtrada;
      };
    },

    getPeriodDespesas: (state) => {
      return (periodo) => {
        let filtrada = state.despesas;
        filtrada = filtrada.filter(
          (despesa) =>
            new Date(despesa.data).getTime() >= new Date(periodo.inicio).getTime() &&
            new Date(despesa.data).getTime() <= new Date(periodo.final).getTime()
        );

        let total = Number(0.0);
        filtrada.forEach((desp) => {
          total = total + parseFloat(desp.valor);
        });
        state.totalDespesas = parseFloat(total).toFixed(2);

        return filtrada;
      };
    },

    getEquipeLoad(state) {
      return state.loaded;
    },
  },
});
